import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CalendarIcon, PhoneIcon } from 'lucide-react';
export function BookingButton() {
  const [showLabel, setShowLabel] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShowLabel(false), 4000);
    return () => clearTimeout(timer);
  }, []);
  return <motion.div initial={{
    opacity: 0,
    y: 40
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 1.5,
    ease: 'easeOut'
  }} className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-id="element-137">
      {/* Phone number pill */}
      <a href="tel:8623889571" className="flex items-center gap-2 bg-[#222222] border border-gold/30 text-cream font-body text-sm px-4 py-2 rounded-full hover:border-gold/60 transition-colors shadow-lg" data-id="element-138">
        <PhoneIcon className="w-4 h-4 text-gold" data-id="element-139" />
        <span data-id="element-140">862-388-9571</span>
      </a>

      {/* Main booking button */}
      <motion.a href="tel:8623889571" whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onMouseEnter={() => setShowLabel(true)} onMouseLeave={() => setShowLabel(false)} className="flex items-center gap-3 gold-shimmer px-5 py-4 rounded-full shadow-[0_4px_20px_rgba(201,168,76,0.4)] pulse-gold cursor-pointer" data-id="element-141">
        <CalendarIcon className="w-6 h-6 text-[#1A1A1A]" data-id="element-142" />
        <AnimatePresence data-id="element-143">
          {showLabel && <motion.span initial={{
          width: 0,
          opacity: 0
        }} animate={{
          width: 'auto',
          opacity: 1
        }} exit={{
          width: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="font-body font-bold uppercase tracking-wider text-sm text-[#1A1A1A] whitespace-nowrap overflow-hidden" data-id="element-144">
              Agendar Cita
            </motion.span>}
        </AnimatePresence>
      </motion.a>
    </motion.div>;
}